import apiSlice from "../api/apiSlice";

export const erseApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* POST */
    addNewTariffs: builder.mutation({
      query: ({ file }) => {
        const formData = new FormData();

        formData.append("file", file, file.name);

        return {
          url: `/erse/tariffs`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "ERSE", id: "LIST" }],
    }),
    /* GET */
    getTariffsValidities: builder.query({
      query: () => ({
        url: `/erse/tariffs/validities`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      providesTags: [{ type: "ERSE", id: "LIST" }],
    }),
    getTariffsByValidity: builder.query({
      query: (validity) => ({
        url: `/erse/tariffs/${validity}`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
    }),
    getEnergyTariffValue: builder.query({
      query: ({ validity, icVoltageLevel, iprVoltageLevel, period, ciegDiscount }) => ({
        url: `/erse/tariffs/energy/value`,
        method: "GET",
        params: {
          validity,
          ic_voltage_level: icVoltageLevel,
          ipr_voltage_level: iprVoltageLevel,
          period,
          cieg_discount: ciegDiscount,
        },
      }),
      providesTags: [{ type: "ERSE", id: "ENERGY_TARIFF" }],
    }),
    /* DELETE */
    deleteTariffsByValidity: builder.mutation({
      query: (value) => ({
        url: `/erse/tariffs/${value}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "ERSE", id: "LIST" }],
    }),
  }),
});

export const {
  useAddNewTariffsMutation,
  useGetTariffsByValidityQuery,
  useGetTariffsValiditiesQuery,
  useGetEnergyTariffValueQuery,
  useDeleteTariffsByValidityMutation,
} = erseApiSlice;
